import type { ComparisonOffer, ComparisonPreferences, ComparisonRow } from './ComparisonTypes'

/**
 * ComparisonRanking — intelligent offer ranking inside a product row.
 */
export class ComparisonRanking {
  rankOffers(
    offers: ComparisonOffer[],
    preferences: Pick<ComparisonPreferences, 'preferredProvider' | 'favoriteSuppliers'>,
  ): ComparisonOffer[] {
    return [...offers].sort((a, b) => {
      const score = (offer: ComparisonOffer) => {
        let value = 0
        if (offer.isBestPrice) value += 40
        if (offer.isBestDelivery) value += 20
        if (offer.isBestStock) value += 15
        if (offer.isBestMargin) value += 10
        if (offer.stock > 0) value += 10
        if (preferences.preferredProvider === offer.supplierId) value += 25
        if (preferences.favoriteSuppliers.includes(offer.supplierId)) value += 12
        value -= Math.min(30, offer.priceDiffPercent)
        return value
      }
      return score(b) - score(a) || a.price - b.price
    })
  }

  rankRows(rows: ComparisonRow[], preferences: ComparisonPreferences): ComparisonRow[] {
    return rows.map((row) => ({
      ...row,
      offers: this.rankOffers(row.offers, preferences),
      recommendedSupplier:
        this.rankOffers(row.offers, preferences)[0]?.supplierName ?? row.recommendedSupplier,
    }))
  }
}

export const comparisonRanking = new ComparisonRanking()
